import script from "./RemaindersBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./RemaindersBlock.vue?vue&type=script&setup=true&lang=js"

import "./RemaindersBlock.vue?vue&type=style&index=0&id=04204be8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04204be8"]])

export default __exports__